
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppButton, AppCard, AppSelect, AppDateTimePicker } from '@/components';
import { useSubscriptionAdd } from '@/modules/subscription/item/model/add';
import { ROUTE_NAME_SUBSCRIPTION } from '@/modules/subscription/router';

export default defineComponent({
    name: ROUTE_NAME_SUBSCRIPTION.ADD,
    components: { AppFormRow, AppInput, AppButton, AppSelect, AppCard, AppDateTimePicker },
    setup() {
        const { model, v$, timeUnits, actions, iapOptions } = useSubscriptionAdd();

        return { v$, model, timeUnits, iapOptions, actions };
    }
});
